module.exports = __webpack_public_path__ + "img/up-arrow.81399a53.png";